<div class="top-0 w-screen h-screen overflow-hidden flex flex-wrap justify-center content-center z-[999999] bg-white bg-opacity-70 fixed">
    <div class="loader"></div>
</div>



